import * as INSIGHT_ACTION from 'constant/action/insight'
import { handleActions } from 'redux-actions'

const initialState = {
  insights: {},
  pagination: {},
  searchTerm: ''
}

export default handleActions(
  {
    [INSIGHT_ACTION.UPDATE_INSIGHTS]: (state, action) => ({
      ...state,
      insights: action.payload
    }),
    [INSIGHT_ACTION.UPDATE_INSIGHT_PAGINATION]: (state, action) => ({
      ...state,
      pagination: action.payload
    }),
    [INSIGHT_ACTION.UPDATE_INSIGHT_SEARCH_TERM]: (state, action) => ({
      ...state,
      searchTerm: action.payload
    })
  },
  initialState
)
